import axios from 'axios';
import {logout} from './services/MadricService';

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVERIP + '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
    (config) => {
      const accessToken = localStorage.getItem('accessToken');
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
);

api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
      // logout the user and redirect to the login page
        logout(); // call your logout function here
        localStorage.removeItem('accessToken');
        localStorage.removeItem('connUser');
        window.location.href = '/login'; // redirect to the login page
      }
      return Promise.reject(error);
    },
);

export default api;
